import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Styles from "../../../LeadsSalesView/LeadsSalesProfileManagementView/Sections/LeadInquiriesView/LeadInquiriesView.module.scss";
import { MatchedNewUnitCard } from "./MatchedNewUnitCard";
import { GlobalHistory ,  bottomBoxComponentUpdate } from '../../../../../Helper' ; 
import {  PaginationComponent } from '../../../../../Components' ;
import { ActiveInquiryViewsEnum } from "../../../LeadsSalesView/LeadsSalesProfileManagementView/Sections/LeadInquiriesView/ActiveInquiryViewsEnum";
import MatchedUnitOverview from "../../../LeadsSalesView/LeadsSalesProfileManagementView/Sections/LeadInquiriesView/MatchedUnitOverview/MatchedUnitOverview";

export const LeadMatchingUnitsCards = ({
  parentTranslationPath,
  translationPath,
  data,
  totalCount,
  saleMatching,
  activeUnit,
  setActiveUnit,
  setActiveView,
  activeView,
  activeItem,
  isSmartProposalActive,
  setCheckedDetailedCards,
  getIsSelectedCard,
  setCheckedCards,
  onCardCheckboxClick,
  activeLead
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const viewChangeHandler = useCallback(({ view, unit }) => {
    setActiveView(view);
    setActiveUnit(unit || null);
  }, []);

  return (
    <>
      <div className={`${Styles.Heading_box} mx-3 mb-4 px-3`}>
        <div className={Styles.Heading}>
          {activeView !== ActiveInquiryViewsEnum.UnitOverview && (
            <h3
              onClick={() =>
                viewChangeHandler({
                  view: ActiveInquiryViewsEnum.MatchedUnit,
                })
              }
            >
              {t(`matched-units`)}
              {totalCount ? ` = ${totalCount}` : "0"}
            </h3>
          )}
          {activeView == ActiveInquiryViewsEnum.UnitOverview ? (
            <>
              <span
                className={`mdi mdi-page-last mt-1 mx-2`}
                onClick={() =>
                  viewChangeHandler({
                    view: ActiveInquiryViewsEnum.MatchedUnit,
                  })
                }
              ></span>
              <h4>
                <span>{activeUnit?.unit?.propertyName || null}</span>
                <span className="mx-2">
                  {activeUnit?.unit?.unit_ref_no
                    ? `( ${activeUnit?.unit.unit_ref_no} )`
                    : "overview"}
                </span>
              </h4>
            </>
          ) : null}
        </div>
      </div>
      {activeView === ActiveInquiryViewsEnum.MatchedUnit ? (
        <div className="units-cards-wrapper d-flex m-3 flex-wrap gap-16">
          {data?.result &&
            data.result.map((item , index) =>
              item ? (
                <MatchedNewUnitCard
                  key={item?.unitId}
                  data={item}
                  actionButtons={{
                    sendPropsal: true,
                    openOverView: true,
                    viewUnit: true,
                  }}
                  viewUnitHandler={() =>
                    viewChangeHandler({
                      view: ActiveInquiryViewsEnum.UnitOverview,
                      unit: item,
                    })
                  }
                  translationPath={translationPath}
                  parentTranslationPath={parentTranslationPath}
                  isLease={!saleMatching}
                  isSmartProposalActive={isSmartProposalActive}
                  setCheckedDetailedCards={setCheckedDetailedCards}
                  getIsSelectedCard={getIsSelectedCard}
                  index={index}
                  onCardCheckboxClick={onCardCheckboxClick}
                  activeLead={activeLead}
                  saleMatching={saleMatching}


                />
              ) : null
            )}
        </div>
      ) : null}
      {activeView === ActiveInquiryViewsEnum.UnitOverview ? (
        <div
          style={{
            width: "95%",
            margin: "auto",
          }}
        >
          <MatchedUnitOverview
            actionButtons={{
              sendPropsal: true,
            }}
            unitId={activeUnit?.unitId}
            isLease={!saleMatching}
            isMatchingFromLeadView={true}
            saleMatching={saleMatching}
          />
        </div>
      ) : null}
    </>
  );
};
